import script from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=0eece46c&lang=scss"

const __exports__ = script;

export default __exports__